const devConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalToken: process.env.REACT_APP_SUPPORT_PAL_TOKEN,
  supportPalUrl: process.env.REACT_APP_SUPPORT_URL,
  apiUrl: localStorage.getItem('region_ocp_zone') === 'pl-1' ? process.env.REACT_APP_API_DEV_URL_SECOND : process.env.REACT_APP_API_DEV_URL, 
  keycloakUrl:process.env.REACT_APP_KEYCLOAK_DEV_URL,
  realmName: 'Onecloud',
  docs_url: localStorage.getItem('lang') === 'uk' ? process.env.REACT_APP_DOCS_URL_UA : process.env.REACT_APP_DOCS_URL
}

const prodConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalToken: process.env.REACT_APP_SUPPORT_PAL_TOKEN,
  supportPalUrl: process.env.REACT_APP_SUPPORT_URL,
  apiUrl: localStorage.getItem('region_ocp_zone') === 'nl-1' ? 'https://admin-nl.ocplanet.cloud/backend/' : localStorage.getItem('region_ocp_zone') === 'pl-1' ? process.env.REACT_APP_API_PROD_PL : process.env.REACT_APP_API_PROD_URL,
  keycloakUrl:process.env.REACT_APP_KEYCLOAK_PROD_URL, 
  realmName: 'onecloud',
  docs_url: localStorage.getItem('lang') === 'uk' ? process.env.REACT_APP_DOCS_URL_UA : process.env.REACT_APP_DOCS_URL
}
const newConfig = {
  tinyToken:process.env.REACT_APP_TINY_TOKEN,
  supportPalToken: process.env.REACT_APP_SUPPORT_PAL_TOKEN,
  supportPalUrl: process.env.REACT_APP_SUPPORT_URL,
  apiUrl: 'https://admin.dev.ocplanet.cloud/backend/',
  keycloakUrl:'https://auth.netengi.ua/auth', 
  realmName: 'Onecloud',
  // realmName: 'sendbox',
  docs_url: localStorage.getItem('lang') === 'uk' ? process.env.REACT_APP_DOCS_URL_UA : process.env.REACT_APP_DOCS_URL
}
// const rootConfig = process.env.NODE_ENV !== 'production' ? 
// devConfig
//   : 
//     window.location.hostname === 'ocp-front-dev.netengi.com' ?
//       devConfig
//     :
//       prodConfig

const rootConfig = window.location.hostname === 'staff.ocplanet.cloud' ? prodConfig : devConfig

// --- Multi-region map (used by the director dashboard to query all regions at once).
// Existing single-region behaviour above (config.apiUrl) is intentionally unchanged.
export type RegionCode = 'ua-1' | 'pl-1' | 'nl-1'

export const REGION_CODES: RegionCode[] = ['ua-1', 'pl-1', 'nl-1']

export const REGION_DISPLAY_NAMES: Record<RegionCode, { uk: string; en: string; short: string }> = {
  'ua-1': { uk: 'Україна', en: 'Ukraine', short: 'UA' },
  'pl-1': { uk: 'Польща', en: 'Poland', short: 'PL' },
  'nl-1': { uk: 'Нідерланди', en: 'Netherlands', short: 'NL' },
}

export const REGION_API_URLS: { dev: Record<RegionCode, string | undefined>; prod: Record<RegionCode, string | undefined> } = {
  dev: {
    'ua-1': process.env.REACT_APP_API_DEV_URL,
    'pl-1': process.env.REACT_APP_API_DEV_URL_SECOND,
    'nl-1': process.env.REACT_APP_API_DEV_URL,
  },
  prod: {
    'ua-1': process.env.REACT_APP_API_PROD_URL,
    'pl-1': process.env.REACT_APP_API_PROD_PL,
    'nl-1': 'https://admin-nl.ocplanet.cloud/backend/',
  },
}

export const isProdEnvironment = () => window.location.hostname === 'staff.ocplanet.cloud'

/** Region → staff backend base URL (ending with "/") for the current environment. */
export const getRegionApiUrls = (): Record<RegionCode, string | undefined> =>
  isProdEnvironment() ? REGION_API_URLS.prod : REGION_API_URLS.dev

export default rootConfig